module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eiyEX"))).then(() => parcelRequire('1iHdE'));